/**
 * Keycloak Configuration Constants
 * Centralized constants for Keycloak initialization and configuration
 */


export const PUBLIC_ROUTES = [
    '/self-registration',
    '/register-by-invite',
    '/resetpassword',
    '/forgot-password',
    '/eula.htm'
];
